var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5C25.4595 21.5 28.6666 18.2929 28.6666 14.3333C28.6666 10.3737 25.4595 7.16666 21.5 7.16666C17.5404 7.16666 14.3333 10.3737 14.3333 14.3333C14.3333 18.2929 17.5404 21.5 21.5 21.5ZM21.5 25.0833C16.7162 25.0833 7.16663 27.4842 7.16663 32.25V35.8333H35.8333V32.25C35.8333 27.4842 26.2837 25.0833 21.5 25.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.7ed72f9d7ba8c7121f057a2f1f4d121c.svg";
export { ForwardRef as ReactComponent };